var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var template = "\n  <div class=\"tip\">\n    <transition :name=\"$effect\" mode=\"out-in\">\n      <div ref=\"content\" v-if=\"state === 1\" class=\"tip__content\" :class=\"innerClass\">\n        {{$message}}\n        <slot></slot>\n      </div>\n    </transition>\n\n    <template v-if=\"useOuterBackground\">\n      <transition :name=\"$backgroundEffect\" mode=\"out-in\">\n        <div v-if=\"state === 1\" @click=\"clickOutsideEvent\" class=\"tip__bg\"></div>\n      </transition>\n    </template>\n  </div>\n";
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { $ } from '../../simpli';
/**
 * @hidden
 */
export var Event = new Vue();
/**
 * @hidden
 */
export var State;
(function (State) {
    State[State["HIDDEN"] = 0] = "HIDDEN";
    State[State["SHOWN"] = 1] = "SHOWN";
})(State || (State = {}));
/**
 * @hidden
 */
export var Position;
(function (Position) {
    Position["TOP"] = "top";
    Position["BOTTOM"] = "bottom";
    Position["LEFT"] = "left";
    Position["RIGHT"] = "right";
})(Position || (Position = {}));
/**
 * @hidden
 */
export var Align;
(function (Align) {
    Align["START"] = "start";
    Align["CENTER"] = "center";
    Align["END"] = "end";
})(Align || (Align = {}));
var TipController = /** @class */ (function () {
    function TipController() {
        this.defaultPosition = Position.TOP;
        this.defaultAlign = Align.CENTER;
        this.defaultMessage = '';
        this.defaultTransition = null;
        this.defaultBackgroundTransition = 'fade';
        this.defaultWidth = 'auto';
        this.defaultOffset = 0;
    }
    TipController.prototype.show = function (name, payload) {
        Event.$emit('show', name, payload);
    };
    TipController.prototype.hide = function (name) {
        Event.$emit('hide', name);
    };
    TipController.prototype.toggle = function (name, payload) {
        Event.$emit('toggle', name, payload);
    };
    TipController.prototype.hideAll = function () {
        Event.$emit('hideAll');
    };
    return TipController;
}());
export { TipController };
var Tip = /** @class */ (function (_super) {
    __extends(Tip, _super);
    function Tip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = State.HIDDEN;
        _this.$position = Position.TOP;
        _this.$align = Align.CENTER;
        _this.$message = null;
        _this.$effect = null;
        _this.$backgroundEffect = null;
        _this.$width = null;
        _this.$offset = null;
        return _this;
    }
    Tip.prototype.setY = function (top, bottom) {
        var el = this.$refs.content;
        el.style.top = top;
        el.style.bottom = bottom;
    };
    Tip.prototype.setX = function (left, right) {
        var el = this.$refs.content;
        el.style.left = left;
        el.style.right = right;
    };
    Tip.prototype.resetEffect = function (effect) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$effect = effect;
                        this.state = State.HIDDEN;
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.state = State.SHOWN;
                        return [2 /*return*/];
                }
            });
        });
    };
    Tip.prototype.stateEvent = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var screenRect, el, offset, width, areaWidth, xCenter, elRect, postElRect, xMin, xMax, xMinScreen, xMaxScreen, hasReachedLeftBoundary, hasReachedRightBoundary, xOffset, effect, xOffset, effect;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(val === State.SHOWN)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        screenRect = document.body.getBoundingClientRect();
                        el = this.$refs.content;
                        offset = this.offset || 0;
                        width = Math.min(Number(this.$width), screenRect.width - 2 * offset);
                        areaWidth = this.$el.scrollWidth;
                        switch (this.$position) {
                            case Position.TOP:
                                this.setY('auto', "calc(100% + " + offset + "px)");
                                break;
                            case Position.BOTTOM:
                                this.setY("calc(100% + " + offset + "px)", 'auto');
                                break;
                        }
                        if (!!isNaN(width)) return [3 /*break*/, 7];
                        xCenter = (areaWidth - width) / 2 - offset;
                        el.style.width = width + "px";
                        el.style.left = xCenter + "px";
                        el.style.right = 'auto';
                        elRect = el.getBoundingClientRect();
                        el.style.marginLeft = offset + "px";
                        el.style.marginRight = offset + "px";
                        if (this.$position === Position.TOP || this.$position === Position.BOTTOM) {
                            switch (this.$align) {
                                case Align.START:
                                    this.setX(-offset + "px", 'auto');
                                    break;
                                case Align.END:
                                    this.setX('auto', -offset + "px");
                                    break;
                                case Align.CENTER:
                                    this.setX(xCenter + "px", 'auto');
                                    break;
                            }
                        }
                        else if (this.$position === Position.LEFT || this.$position === Position.RIGHT) {
                            switch (this.$position) {
                                case Position.LEFT:
                                    this.setX('auto', '100%');
                                    break;
                                case Position.RIGHT:
                                    this.setX('100%', 'auto');
                                    break;
                            }
                            switch (this.$align) {
                                case Align.START:
                                    this.setY('0', 'auto');
                                    break;
                                case Align.END:
                                    this.setY('auto', '0');
                                    break;
                                case Align.CENTER:
                                    this.setY("calc(50% - " + elRect.height / 2 + "px)", 'auto');
                                    break;
                            }
                        }
                        postElRect = el.getBoundingClientRect();
                        xMin = elRect.x;
                        xMax = elRect.x + elRect.width + offset * 2;
                        if (this.$position === Position.LEFT || this.$position === Position.RIGHT) {
                            xMin = postElRect.x;
                            xMax = postElRect.x + postElRect.width + offset * 2;
                        }
                        xMinScreen = screenRect.x;
                        xMaxScreen = screenRect.x + screenRect.width;
                        hasReachedLeftBoundary = xMin < xMinScreen;
                        hasReachedRightBoundary = xMax > xMaxScreen;
                        if (!hasReachedLeftBoundary) return [3 /*break*/, 4];
                        xOffset = Math.abs(xMin - xMinScreen);
                        this.setX(xCenter + xOffset + "px", 'auto');
                        if (!(this.$position === Position.LEFT)) return [3 /*break*/, 3];
                        effect = 'fade-up';
                        this.setX('0', 'auto');
                        switch (this.$align) {
                            case Align.START:
                                this.setY('auto', "calc(100% + " + offset + "px)");
                                break;
                            case Align.END:
                                this.setY("calc(100% + " + offset + "px)", 'auto');
                                effect = 'fade-down';
                                break;
                            case Align.CENTER:
                                this.setY('auto', "calc(100% + " + offset + "px)");
                                break;
                        }
                        if (!(this.$effect === 'fade-left')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.resetEffect(effect)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        if (!hasReachedRightBoundary) return [3 /*break*/, 6];
                        xOffset = Math.abs(xMax - xMaxScreen);
                        this.setX(xCenter - xOffset + "px", 'auto');
                        if (!(this.$position === Position.RIGHT)) return [3 /*break*/, 6];
                        effect = 'fade-up';
                        this.setX('auto', '0');
                        switch (this.$align) {
                            case Align.START:
                                this.setY('auto', "calc(100% + " + offset + "px)");
                                break;
                            case Align.END:
                                this.setY("calc(100% + " + offset + "px)", 'auto');
                                effect = 'fade-down';
                                break;
                            case Align.CENTER:
                                this.setY('auto', "calc(100% + " + offset + "px)");
                                break;
                        }
                        if (!(this.$effect === 'fade-right')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.resetEffect(effect)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.setX('0', '0');
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Tip.prototype.show = function (payload) {
        this.state = State.SHOWN;
        this.$emit('show', payload);
    };
    Tip.prototype.hide = function () {
        this.state = State.HIDDEN;
        this.$emit('hide');
    };
    Tip.prototype.clickOutsideEvent = function () {
        this.$emit('clickOutside');
    };
    Tip.prototype.beforeMount = function () {
        var _this = this;
        this.$position = this.position || $.tip.defaultPosition;
        this.$align = this.align || $.tip.defaultAlign;
        this.$message = this.message || $.tip.defaultMessage;
        this.$effect = this.effect || $.tip.defaultTransition;
        this.$backgroundEffect = this.backgroundEffect || $.tip.defaultBackgroundTransition;
        this.$width = this.width || $.tip.defaultWidth;
        this.$offset = this.offset || $.tip.defaultOffset;
        if (this.$effect === 'auto') {
            switch (this.$position) {
                case Position.TOP:
                    this.$effect = 'fade-up';
                    break;
                case Position.BOTTOM:
                    this.$effect = 'fade-down';
                    break;
                case Position.LEFT:
                    this.$effect = 'fade-left';
                    break;
                case Position.RIGHT:
                    this.$effect = 'fade-right';
                    break;
            }
        }
        Event.$on('show', function (name, payload) {
            if (name === _this.name)
                _this.show(payload);
        });
        Event.$on('hide', function (name) {
            if (name === _this.name)
                _this.hide();
        });
        Event.$on('toggle', function (name, payload) {
            if (name === _this.name) {
                if (_this.state === State.SHOWN)
                    _this.hide();
                else if (_this.state === State.HIDDEN)
                    _this.show(payload);
            }
        });
        Event.$on('hideAll', function () {
            _this.hide();
        });
    };
    Tip.prototype.mounted = function () {
        var parentElement = this.$el.parentElement;
        if (parentElement) {
            parentElement.style.position = 'relative';
        }
    };
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Tip.prototype, "name", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Tip.prototype, "position", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Tip.prototype, "align", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Tip.prototype, "message", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Tip.prototype, "effect", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Tip.prototype, "backgroundEffect", void 0);
    __decorate([
        Prop({ type: [String, Number] }),
        __metadata("design:type", String)
    ], Tip.prototype, "width", void 0);
    __decorate([
        Prop({ type: Number, default: 5 }),
        __metadata("design:type", Number)
    ], Tip.prototype, "offset", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Tip.prototype, "innerClass", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], Tip.prototype, "useOuterBackground", void 0);
    __decorate([
        Watch('state'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], Tip.prototype, "stateEvent", null);
    Tip = __decorate([
        Component({ template: template })
    ], Tip);
    return Tip;
}(Vue));
export { Tip };
//# sourceMappingURL=Tip.js.map